"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVehicleRegions = void 0;
/**
 * Get a list of Vehicle Regions

Built-in filters `eq`, `neq`, `lt`, `lte`, `gt`, `gte`, `like`, `likeLower`, `in`, `notNull` or `isNull`

Example:
```
  ?vehicle_type:in=maxi,luton,caged&orderBy=date&order=asc
```

Utilises [Objection Find](https://github.com/Vincit/objection-find).

 */
var getVehicleRegions = function (instance) { return function (config) {
    return instance.get("/vehicles/regions", config);
}; };
exports.getVehicleRegions = getVehicleRegions;
